import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function I() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('I_list1_title'),
            desc: t('I_list1_desc'),
        },
        {
            title: t('I_list2_title'),
            desc: t('I_list2_desc'),
        },
        {
            title: t('I_list3_title'),
            desc: t('I_list3_desc'),
        },
        {
            title: t('I_list4_title'),
            desc: t('I_list4_desc'),
        },
    ];
    if (locale === 'es') {
        lists.pop();
    }
    return (
        <div id="RV-I" className={`RV-I RV-box ${css['RV-I']}`}>
            <div className="info-box">
                <p className="title">{t('I_title')}</p>
            </div>
            <div className="inner">
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="swiper-item-text">
                                <p className="card-desc">{card?.desc}</p>
                                <p className="card-title">{card?.title}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
